import {useEffect} from 'react';

export function useScreenWakeLock() {
  useEffect(() => {
    let wakeLock: WakeLockSentinel | null = null;
    let released = false;

    const acquire = async () => {
      try {
        wakeLock = await navigator.wakeLock.request('screen');
        wakeLock.addEventListener('release', () => {
          wakeLock = null;
        });
      } catch {
        // Wake Lock API not supported or permission denied — ignore silently
      }
    };

    acquire();

    // Re-acquire wake lock when tab regains visibility (browser releases it on tab switch)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && !released) {
        acquire();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      released = true;
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      wakeLock?.release();
    };
  }, []);
}
